import { readonly, ref } from "vue";

// Tracks whether the user is navigating focus with the keyboard (Tab) rather than a mouse or touch.
let installed = false;

const isTabbing = ref<boolean>(false);

function handleKeydown(event: KeyboardEvent): void {
  if (isTabbing.value || event.metaKey || event.altKey || event.ctrlKey) return;

  if (event.key !== "Tab") return;

  isTabbing.value = true;
}

function handlePointerDown(): void {
  if (!isTabbing.value) return;

  isTabbing.value = false;
}

function setup(): void {
  if (installed || typeof window === "undefined") return;

  installed = true;

  window.addEventListener("keydown", handleKeydown, true);
  window.addEventListener("pointerdown", handlePointerDown, true);
}

export default function useTabbing() {
  setup();

  return {
    isTabbing: readonly(isTabbing),
  };
}
